import React from 'react'
import s from './styles/StepTypeActivity.module.scss'
import { useStepTypeActivity } from './hooks/useStepTypeActivity'
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg'

const StepTypeActivity = ({ activityType, onSelect }) => {
	const { types } = useStepTypeActivity()

	return (
		<div className={s.root}>
			<header className={s.header}>
				<h2 className={s.header__title}>Select An Assignment</h2>
				<p className={s.header__subtitle}>
					Choose the assignment format that best fits your needs
				</p>
			</header>

			<div className={s.grid}>
				{types.map(type => {
					const isActive = activityType === type.id

					return (
						<button
							key={type.id}
							type="button"
							className={`${s.card} ${isActive ? s.card_active : ''}`}
							onClick={() => onSelect?.(type.id)}
						>
							<div className={s.card__title}>
								{type.emoji && (
									<span className={s.card__emoji}>{type.emoji}</span>
								)}
								<span className={s.card__titleText}>{type.title}</span>
							</div>
							<div className={s.card__subtitle}>{type.subtitle}</div>
							{isActive && (
								<span className={s.card__check} aria-hidden="true">
									<CheckIcon />
								</span>
							)}
						</button>
					)
				})}
			</div>
		</div>
	)
}

export default StepTypeActivity
